import { HStack } from "@chakra-ui/react";
import { FC } from "react";

import { GhostButton } from "~/src/components/common/Button";
import { Modal } from "~/src/components/common/Modal";

import { UrlMappingPreviewPanel } from "../../UrlMappingForm/UrlMappingPreviewPanel";

export type Props = {
  isOpen: boolean;
  onClose: () => void;
  siteSlug: string;
};

export const UrlMappingTestModal: FC<Props> = ({
  isOpen,
  onClose,
  siteSlug,
}) => {
  return (
    <Modal title="URLテスト" isOpen={isOpen} onClose={onClose} width="720px">
      <UrlMappingPreviewPanel siteSlug={siteSlug} />
      <HStack spacing="8px" justifyContent="flex-end" mt="16px">
        <GhostButton onClick={onClose}>閉じる</GhostButton>
      </HStack>
    </Modal>
  );
};
